// extracted by mini-css-extract-plugin
module.exports = {"body":"TextLogin_body__15Mmr"};